export type PlaceCategoryId = "all" | "beach" | "stream" | "port" | "tide_station" | "shn_argentina";
export type MobileMapFilterId = PlaceCategoryId | "followed";

export interface MobileMapFilterSelection {
  categoryId: PlaceCategoryId;
  showFollowed: boolean;
  showAll: boolean;
}

export const selectMobileMapFilter = (
  filterId: MobileMapFilterId,
  favoritesOnly: boolean,
): MobileMapFilterSelection => ({
  categoryId: filterId === "followed" ? "all" : filterId,
  showFollowed: filterId === "followed" && !favoritesOnly,
  showAll: filterId !== "followed" && favoritesOnly,
});

export interface PlaceCategory {
  id: Exclude<PlaceCategoryId, "all">;
  label: string;
}

export const PLACE_CATEGORIES: readonly PlaceCategory[] = [
  { id: "beach", label: "Playas" },
  { id: "stream", label: "Arroyos" },
  { id: "port", label: "Puertos (ANP)" },
  { id: "tide_station", label: "Mareógrafos" },
  { id: "shn_argentina", label: "SHN Argentina" },
];

/**
 * Categoría de navegación derivada únicamente del ID canónico.
 * No usa títulos públicos ni la agrupación histórica del dashboard.
 */
export const getPlaceCategoryId = (contextId: string): Exclude<PlaceCategoryId, "all"> => {
  if (contextId.startsWith("playa_mvd_arroyo_")) return "stream";
  if (contextId.startsWith("playa_mvd_")) return "beach";
  if (contextId.startsWith("anp_")) return "port";
  if (contextId.startsWith("shn_")) return "shn_argentina";
  return "tide_station";
};

export const matchesPlaceCategory = (
  contextId: string,
  categoryId: PlaceCategoryId
): boolean => {
  if (categoryId === "all") return true;
  const contextCategory = getPlaceCategoryId(contextId);
  return contextCategory === categoryId
    || (categoryId === "tide_station" && contextCategory === "shn_argentina");
};
